export const pageTexts = (t) => {
  const NUMBER = 4; // 4 title + text on the Privacy Policy Page
  let termsText = [
    {
      text: t("privacy-policy.firstParagraph1"),
      colorClass: "colorDark",
      textType: "paragraph",
      extraClass: "font14 pt-20 termsStyle",
    },
    {
      text: t("privacy-policy.firstParagraph2"),
      colorClass: "colorDark",
      textType: "paragraph",
      extraClass: "font14 termsStyle",
    },
    {
      text: t("privacy-policy.firstParagraph3"),
      colorClass: "colorDark",
      textType: "paragraph",
      extraClass: "font14 termsStyle",
    },
  ];
  for (let i = 1; i <= NUMBER; i++) {
    termsText.push({
      text: t("privacy-policy." + i + "title"),
      colorClass: "colorDark",
      textType: "subtitle",
      extraClass: "font18 pt-20 fontWeightBold",
    });
    termsText.push({
      text: t("privacy-policy." + i + "text"),
      colorClass: "colorDark",
      extraClass: "font14 lineHeight1_7 termsStyle",
      textType: "paragraph",
      heading: "div",
    });
  }

  return {
    topTitle: {
      title: {
        text: t("privacy-policy.privacyTitle"),
        colorClass: "colorDark",
        extraClass: "font26 text-center",
        heading: "h1",
      },
      text: {
        text: t("privacy-policy.version"),
        colorClass: "colorDark",
        extraClass: "font14 text-center",
      },
      separator: false,
    },
    terms: termsText,
  };
};
